"use strict";

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureTopicStats = exports.createTopicStats = exports.createPeerStats = void 0;

function createPeerStats() {
  var ps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.assign(Object.assign({
    connected: false,
    expire: 0,
    ips: [],
    behaviourPenalty: 0
  }, ps), {
    topics: ps.topics ? Object.entries(ps.topics).reduce(function (topics, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          topic = _ref2[0],
          topicStats = _ref2[1];

      topics[topic] = createTopicStats(topicStats);
      return topics;
    }, {}) : {}
  });
}

exports.createPeerStats = createPeerStats;

function createTopicStats() {
  var ts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.assign({
    inMesh: false,
    graftTime: 0,
    meshTime: 0,
    firstMessageDeliveries: 0,
    meshMessageDeliveries: 0,
    meshMessageDeliveriesActive: false,
    meshFailurePenalty: 0,
    invalidMessageDeliveries: 0
  }, ts);
}

exports.createTopicStats = createTopicStats;

function ensureTopicStats(topic, ps, params) {
  var ts = ps.topics[topic];

  if (ts) {
    return ts;
  }

  if (!params.topics[topic]) {
    return undefined;
  }

  ps.topics[topic] = ts = createTopicStats();
  return ts;
}

exports.ensureTopicStats = ensureTopicStats;